var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.4707 175C58.0481 175 24.4707 141.423 24.4707 100C24.4707 58.5774 58.0481 25 99.4707 25C140.893 25 174.471 58.5774 174.471 100C174.471 141.423 140.893 175 99.4707 175Z",
    fill: "url(#paint0_linear_26801_879)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9589 91.3233C16.877 87.2857 19.2732 83.1355 23.3108 82.0536L96.419 62.4643C100.457 61.3824 104.607 63.7785 105.689 67.8162L121.36 126.303C122.442 130.34 120.046 134.491 116.008 135.573L42.9001 155.162C38.8624 156.244 34.7122 153.847 33.6304 149.81L17.9589 91.3233Z",
    fill: "url(#paint1_linear_26801_879)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0791 105.42C58.4627 103.978 61.6575 98.4439 60.215 93.0604C58.7725 87.6769 53.2388 84.482 47.8553 85.9245C42.4718 87.3671 39.2769 92.9007 40.7194 98.2842C42.162 103.668 47.6956 106.863 53.0791 105.42Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6771 142.898L103.993 128.344C105.58 127.919 106.154 126.052 105.048 124.928L80.8495 102.112C79.7322 101.116 77.8838 101.569 77.3199 102.974L69.5316 125.041L60.7884 119.648C59.744 119.092 58.3654 119.462 57.7911 120.493L47.1807 140.266C46.5229 141.821 47.9643 143.357 49.6771 142.898Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8838 59.4C36.8838 54.7608 40.6446 51 45.2838 51H129.284C133.923 51 137.684 54.7608 137.684 59.4V126.6C137.684 131.239 133.923 135 129.284 135H45.2838C40.6446 135 36.8838 131.239 36.8838 126.6V59.4Z",
    fill: "url(#paint2_linear_26801_879)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4839 84.6C76.6694 84.6 81.6839 79.5856 81.6839 73.4C81.6839 67.2144 76.6694 62.2 70.4839 62.2C64.2983 62.2 59.2839 67.2144 59.2839 73.4C59.2839 79.5856 64.2983 84.6 70.4839 84.6Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0714 123.8H118.479C120.303 123.8 121.455 121.963 120.592 120.44L101.204 89.0307C100.293 87.6419 98.1809 87.5971 97.1729 88.9411L82.4851 110.36L74.6613 102.068C73.7013 101.171 72.1174 101.171 71.2054 102.112L54.1515 120.261C52.9995 121.739 54.1035 123.8 56.0714 123.8Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.633 36.4335C69.029 31.2235 74.3841 28.1317 79.5941 29.5277L173.929 54.8046C179.139 56.2006 182.231 61.5558 180.835 66.7658L160.613 142.234C159.217 147.443 153.862 150.535 148.652 149.139L54.3172 123.862C49.1072 122.466 46.0155 117.111 47.4114 111.901L67.633 36.4335Z",
    fill: "url(#paint3_linear_26801_879)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8022 114.531L139.888 133.31C141.936 133.859 143.783 132.143 143.271 130.172L130.951 89.0647C130.345 87.2307 127.987 86.5449 126.45 87.751L103.51 107.385L97.2188 95.7183C96.4104 94.4232 94.6316 93.9465 93.3243 94.7287L68.711 109.978C66.9724 111.292 67.5921 113.938 69.8022 114.531Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7837 74.8447C104.73 76.706 111.871 72.5836 113.732 65.637C115.593 58.6903 111.471 51.5501 104.524 49.6887C97.5776 47.8274 90.4374 51.9498 88.576 58.8964C86.7147 65.8431 90.8371 72.9833 97.7837 74.8447Z",
    fill: "url(#paint4_linear_26801_879)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 133.694C101.5 138.777 105.578 142.889 110.598 142.889C115.618 142.889 119.696 138.777 119.696 133.694C119.696 128.612 115.618 124.5 110.598 124.5C105.578 124.5 101.5 128.612 101.5 133.694Z",
    stroke: "url(#paint5_linear_26801_879)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.598 140.406C114.267 140.406 117.242 137.401 117.242 133.694C117.242 129.988 114.267 126.983 110.598 126.983C106.928 126.983 103.953 129.988 103.953 133.694C103.953 137.401 106.928 140.406 110.598 140.406Z",
    fill: "url(#paint6_linear_26801_879)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.831 126.983C114.372 126.983 117.243 129.988 117.243 133.694C117.243 137.401 114.372 140.406 110.831 140.406C110.501 140.406 110.177 140.38 109.86 140.329C112.94 139.839 115.3 137.055 115.3 133.694C115.3 130.333 112.94 127.549 109.86 127.059C110.177 127.009 110.501 126.983 110.831 126.983Z",
    fill: "url(#paint7_linear_26801_879)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.668 150.872L108.35 136.302C107.388 134.617 107.964 132.443 109.63 131.471C111.296 130.498 113.446 131.082 114.407 132.765L121.235 144.725C120.733 143.146 121.369 141.361 122.844 140.499C124.517 139.523 126.677 140.085 127.674 141.759C127.595 140.551 128.18 139.341 129.282 138.699C130.822 137.8 132.808 138.338 133.697 139.895L133.959 140.354C134.074 139.387 134.621 138.482 135.514 137.961C137.018 137.082 138.959 137.608 139.827 139.129C143.82 146.124 144.405 147.148 147.151 151.958C147.902 153.273 148.254 154.571 148.271 156.089C148.277 156.576 148.409 157.064 148.669 157.518L150.263 160.31C150.574 160.855 150.388 161.556 149.849 161.871L132.451 172.029C131.912 172.344 131.218 172.156 130.907 171.611L129.313 168.819C128.785 167.893 127.879 167.362 126.822 167.358L122.715 167.342C120.392 167.333 118.243 166.502 116.908 164.579L113.371 159.486C111.633 156.44 112.611 153.241 115.622 151.483L116.668 150.872Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.402 139.06C134.668 138.618 135.042 138.236 135.514 137.961C137.019 137.082 138.959 137.608 139.827 139.129C143.82 146.124 144.405 147.148 147.151 151.958C147.902 153.273 148.254 154.571 148.271 156.089C148.277 156.576 148.409 157.064 148.669 157.518L150.263 160.31C150.574 160.855 150.388 161.556 149.849 161.871L147.24 163.394C147.779 163.08 147.965 162.379 147.653 161.834L146.059 159.042C145.8 158.587 145.667 158.1 145.662 157.613C145.645 156.095 145.293 154.797 144.542 153.482C141.796 148.671 141.211 147.647 137.218 140.653C136.622 139.609 135.521 139.034 134.402 139.06ZM127.674 141.759C126.677 140.085 124.517 139.523 122.844 140.499C122.378 140.771 121.996 141.136 121.707 141.556C123.018 141.445 124.345 142.074 125.065 143.282L126.196 145.263C126.612 145.992 127.533 146.242 128.254 145.821C128.975 145.4 129.222 144.468 128.805 143.74C128.428 143.079 128.051 142.419 127.674 141.759ZM128.164 139.789C129.323 139.747 130.47 140.337 131.088 141.418C131.354 141.884 131.619 142.35 131.886 142.816C132.301 143.545 133.223 143.794 133.944 143.374C134.664 142.953 134.911 142.021 134.495 141.292C134.229 140.827 133.963 140.361 133.697 139.895C132.808 138.338 130.821 137.8 129.281 138.699C128.811 138.973 128.435 139.352 128.164 139.789ZM108.497 132.534C108.782 132.11 109.163 131.743 109.63 131.471C111.296 130.498 113.446 131.082 114.407 132.765C117.179 137.622 119.952 142.479 122.725 147.336C123.141 148.065 122.894 148.996 122.173 149.417C121.453 149.838 120.531 149.588 120.115 148.859C117.343 144.003 114.57 139.146 111.797 134.289C111.105 133.077 109.797 132.435 108.497 132.534ZM114.17 152.591C114.582 152.18 115.067 151.807 115.622 151.483L116.668 150.873L120.241 157.131C120.657 157.86 120.41 158.792 119.69 159.213C118.969 159.633 118.048 159.383 117.632 158.655L114.17 152.591Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.313 168.819L148.668 157.518L150.262 160.31C150.573 160.855 150.388 161.556 149.849 161.871L132.45 172.029C131.911 172.344 131.218 172.156 130.907 171.611L129.313 168.819Z",
    fill: "url(#paint8_linear_26801_879)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.06 159.042L148.669 157.518L150.263 160.31L150.277 160.335L150.29 160.361L150.303 160.387L150.315 160.414L150.326 160.44L150.337 160.467L150.347 160.494C150.35 160.503 150.354 160.512 150.356 160.52L150.365 160.547L150.373 160.574L150.38 160.601L150.387 160.629L150.392 160.656L150.397 160.684L150.402 160.711C150.403 160.72 150.404 160.729 150.405 160.739C150.407 160.757 150.409 160.776 150.411 160.794L150.412 160.822L150.413 160.849L150.414 160.877C150.414 160.895 150.413 160.914 150.412 160.932L150.411 160.959L150.408 160.986L150.405 161.014L150.402 161.041C150.399 161.059 150.396 161.077 150.393 161.095C150.389 161.113 150.386 161.131 150.381 161.149L150.375 161.175L150.367 161.202C150.362 161.219 150.356 161.237 150.351 161.254C150.345 161.271 150.338 161.288 150.332 161.305L150.321 161.331L150.31 161.356L150.299 161.381L150.287 161.405C150.278 161.422 150.27 161.438 150.261 161.454L150.247 161.477L150.232 161.501L150.217 161.524C150.207 161.539 150.196 161.554 150.185 161.569L150.168 161.591L150.151 161.613L150.133 161.634L150.115 161.655L150.095 161.675L150.076 161.695L150.056 161.715L150.035 161.734L150.014 161.752L149.992 161.77L149.97 161.788L149.947 161.805L149.923 161.822L149.9 161.838L149.875 161.854L149.85 161.869L147.241 163.392C147.78 163.077 147.966 162.376 147.655 161.831L146.06 159.042Z",
    fill: "#3460DC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_879",
    x1: 24.4707,
    y1: 36.7188,
    x2: 167.439,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_879",
    x1: 44.5122,
    y1: 76.3727,
    x2: 57.1315,
    y2: 149.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_879",
    x1: 69.6438,
    y1: 51,
    x2: 62.243,
    y2: 132.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_879",
    x1: 126.761,
    y1: 42.1662,
    x2: 101.485,
    y2: 136.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_879",
    x1: 94.6977,
    y1: 47.0557,
    x2: 118.929,
    y2: 72.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_879",
    x1: 118.096,
    y1: 124,
    x2: 95.7743,
    y2: 137.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_879",
    x1: 105.406,
    y1: 126.983,
    x2: 120.86,
    y2: 136.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_879",
    x1: 110.667,
    y1: 126.983,
    x2: 121.276,
    y2: 130.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26801_879",
    x1: 132.531,
    y1: 172.182,
    x2: 147.195,
    y2: 157.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageChoice);
export default __webpack_public_path__ + "static/media/Image-Choice.812e7c3b5b447c4e483767c6a6f58142.svg";
export { ForwardRef as ReactComponent };